import { Component, ViewChild, Input, ElementRef, AfterViewInit, Injector } from "@angular/core";
import {
    ChartStokeStyle,
    ChartAnnotationTool,
    ChartMarkerType,
    MarkerAnchorMap,
    EventType
} from "../achart/achart.annotation.tools";
import { ChartInstanceService } from "../../services/chartInstance/chart.instance.service";
import { spaceAfterDataService } from "../../services/spaceAfterDataService/spaceAfterData.service";
import { AChartComponent } from "../achart/achart.component";
import { getChartColorMap } from "../achart/achart.colors";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { ChartLabelModal, ILabelAnnotationData } from "../modals/chart.label/chart.label.component";
import { ColorEvent } from "ngx-color";
import * as Color from "color";

import { ChartLayoutModeService } from "../../services/chartLayoutMode/chartLayoutMode.service";
import { GlobalGridModeService } from "../../services/globalGridMode/globalGridMode.service";
import { OrderOperationType } from "../modals/orderentry/orderentry.component";

import * as $ from "jquery";
import "malihu-custom-scrollbar-plugin/jquery.mCustomScrollbar.concat.min.js";

import { WorkspaceServiceService } from "../../services/workspace-service.service";
import { IdisplayModeForChartDisplayMode } from "../../interfaces/displayModeForChartDisplayMode";
import { AppComponentBase } from '../../services/AppComponentBase';
import { showDemoUsersModal } from "../modals/demoUsers/show-demo-users-modal";
import { ShowModalOrderEntry } from "../modals/orderentry/show-order-entry-modal";
import { Utils } from "../../utils";
import {showLiveUsersModal} from "../modals/liveUsers/show-live-users-modal";

@Component({
    selector: "chartTools",
    template: require('./commonChartToolBar.component.html'),
    styles: [require('./commonChartToolBar.component.css'), require('../../appStyles.css')]
})
export class CommonChartToolBar extends AppComponentBase implements AfterViewInit {
    @ViewChild("modalText") _modalText: any = null;

    public scrollbarOptions = { axis: "yx", theme: "minimal-dark" };
    private _spaceAfterData: boolean = true;
    ToolEnum = ChartAnnotationTool;
    MarkerEnum = ChartMarkerType;

    colors: string[][] = getChartColorMap().sort((a, b) => {
        return a[1].toLowerCase() > b[1].toLowerCase() ? 1 : a[1].toLowerCase() < b[1].toLowerCase() ? -1 : 0;
    });

    strokeWidth: number[] = [1, 2, 3, 4, 5, 10];

    private _strokeColor: string = "White";
    public get strokeColor(): string {
        return this.workspace.strokeColor;
    }
    public set strokeColor(v: string) {
        this.workspace.strokeColor = v;
        this._chartComponents.forEach(cmp => {
            if (cmp.chart) {
                let annotation: any = cmp.chart.annotations().getSelectedAnnotation();
                if (annotation && annotation.stroke !== undefined) {
                    annotation.stroke(v, this.lineThickness);
                    annotation.hovered().stroke(v, this.lineThickness);
                    annotation.selected().stroke(v, this.lineThickness);

                    annotation.normal().labels().fontColor(v);
                    annotation.hovered().labels().fontColor(v);
                    annotation.selected().labels().fontColor(v);
                  //  (annotation as anychart.core.annotations.Base).
                }
            }
        });
    }

    private _fillColor: string = "White";
    public get fillColor(): string {
        return this.workspace.fillColor;
    }
    public set fillColor(v: string) {
        this.workspace.fillColor = v;
        this._chartComponents.forEach(cmp => {
            if (cmp.chart) {
                let annotation: any = cmp.chart.annotations().getSelectedAnnotation();
                if (annotation && annotation.fill !== undefined) {
                    annotation.fill(v);
                }
            }
        });


    }

    private _annotationToolStokeWidth: number = 1;
    public get toolLineWidth(): number {
        return this._annotationToolStokeWidth;
    }
    public set toolLineWidth(v: number) {
        this._annotationToolStokeWidth = v;
        this.updateCharts();
    }

    private _strokeStyle: any = null;
    private _annotationToolStokeStyle: ChartStokeStyle = ChartStokeStyle.Solid;
    public get toolLineStyle(): ChartStokeStyle {
        return this._annotationToolStokeStyle;
    }
    public set toolLineStyle(v: ChartStokeStyle) {
        this._annotationToolStokeStyle = v;
        this._strokeStyle = v === ChartStokeStyle.Solid ? null : v === ChartStokeStyle.Doted ? "1 1" : "10 5";
        this.updateCharts();
    }

    private _labelData: ILabelAnnotationData = {
        labelText: ""
    };
    set labelData(v: ILabelAnnotationData) {
        this._labelData = v;
    }
    get labelData(): ILabelAnnotationData {
        return this._labelData;
    }

    private _annotationTool: ChartAnnotationTool = ChartAnnotationTool.None;
    public get annotationTool(): ChartAnnotationTool {
        return this._annotationTool;
    }
    public set annotationTool(v: ChartAnnotationTool) {
        this._annotationTool = v;
        if (v === ChartAnnotationTool.None && this._annotationMarkerType !== ChartMarkerType.None) {
            this._annotationMarkerType = ChartMarkerType.None;
        }
        this.updateCharts();
    }

    isUnSelectedToolLine(): boolean {
        return (
            this.annotationTool === ChartAnnotationTool.Line ||
            (this.annotationTool !== ChartAnnotationTool.Ray &&
                this.annotationTool !== ChartAnnotationTool.InfiniteLine &&
                this.annotationTool !== ChartAnnotationTool.HorizontalLine &&
                this.annotationTool !== ChartAnnotationTool.VerticalLine)
        );
    }

    private _annotationMarkerType: ChartMarkerType = ChartMarkerType.None;
    public get annotationMarkerType(): ChartMarkerType {
        return this._annotationMarkerType;
    }
    public set annotationMarkerType(v: ChartMarkerType) {
        this._annotationMarkerType = v;
        if (v === ChartMarkerType.None && this._annotationTool !== ChartAnnotationTool.None) {
            this._annotationTool = ChartAnnotationTool.None;
        } else {
            this._annotationTool = ChartAnnotationTool.Marker;
        }
        this.setMarker();
        this.updateCharts();
    }

    private _selectedAnnotationTools: any[] = [];
    get isSelectedAnnotationTool(): boolean {
        return this._selectedAnnotationTools.length > 0;
    }

    private get _chartComponents()
    {
        return Object.keys(this.workspace.charts).map(
            key => this.workspace.charts[key].instance as AChartComponent
        ).filter(ac => ac !== undefined);
    }

    changeSpaceAfterData() {
        let t = this.spaceAfterData ? false : true;
        this.spaceAfterData = t;
        this.spaceAfterDataService.subscriber.next(t);
    }

    set spaceAfterData(v: boolean) {
        this._spaceAfterData = v;
    }

    get spaceAfterData(): boolean {
        return this._spaceAfterData;
    }

    constructor(
        public chartInstanceService: ChartInstanceService,
        public modalService: NgbModal,
        public element: ElementRef,
        private activeLayoutTypeService: ChartLayoutModeService,
        public globalGridService: GlobalGridModeService,
        private spaceAfterDataService: spaceAfterDataService,
        public workspaceService: WorkspaceServiceService,
        injector:Injector,
    ) {
        super(injector);



        let c: Color = Color("red");
        this.fillColor = `rgba(${c.red()},${c.green()},${c.blue()},0.5)`;


        

        this.chartInstanceService.select.subscribe(chartComponent => {
            if (chartComponent) {
                if (this._chartComponents.filter(x => x.InstanceId === chartComponent.InstanceId).length === 0) {

                    chartComponent.chart.listen(EventType.ANNOTATION_DRAWING_FINISH, e => {

                        try{

                       
                        this._chartComponents.forEach(x => {
                            if (x.InstanceId !== chartComponent.InstanceId) {
                                x.chart
                                    .annotations()
                                    .unselect()
                                    .cancelDrawing();
                            }
                        });
                        this.annotationTool = ChartAnnotationTool.None;
                        }
                        catch(e)
                        {
                            console.log(e);
                        }

                    });
                    chartComponent.chart.listen(EventType.ANNOTATION_SELECT, e => {
                        let annotation = (<any>e).annotation;
                        if (annotation !== undefined) {
                            this._selectedAnnotationTools.push(annotation);
                            chartComponent.isSelected = true;
                            if (annotation.fill !== undefined) this._fillColor = annotation.fill() || this._fillColor;
                            if (annotation.stroke !== undefined)
                            {
                                
                               this.strokeColor = annotation.stroke().color;
                               this.lineThickness =annotation.stroke().thickness;

                               
                               //   this._strokeColor = annotation.stroke() || this._strokeColor;
                            }
                              
                        }
                    });
                    chartComponent.chart.listen(EventType.ANNOTATION_UNSELECT, e => {
                        if ((<any>e).annotation !== undefined) {
                            this._selectedAnnotationTools = this._selectedAnnotationTools.filter(
                                x => x !== (<any>e).annotation
                            );
                        }
                    });
                    this.updateChart(chartComponent);
                }
            }
        });

       /* this.chartInstanceService.unselect.subscribe(chartComponent => {
            this.annotationTool = ChartAnnotationTool.None;
            chartComponent.chart
                .annotations()
                .unselect()
                .cancelDrawing();
        });*/

        this.activeLayoutTypeService.subscriber.subscribe(v => {
            if (v && v.length > 0) {
                this.selectedLayoutChart = v[0];
            }
        });
    }

    private setMarker(): void {
        // $(this.markerStyleBtn.nativeElement).empty();
        // if (this.annotationTool === ChartAnnotationTool.Marker) {
        //     let c: string ="";
        //     switch (this.annotationMarkerType) {
        //         case ChartMarkerType.ArrowDown: c="ac-arrow-down-square";break;
        //         case ChartMarkerType.ArrowUp: c="ac-arrow-up-square"; break;
        //         case ChartMarkerType.ArrowLeft: c="ac-arrow-left-square";break;
        //         case ChartMarkerType.ArrowRight: c="ac-arrow-right-square";break;
        //         case ChartMarkerType.ArrowHead: c="ac-head-arrow";break;
        //         case ChartMarkerType.Cross: c="ac-cross";break;
        //         case ChartMarkerType.DiagonalCross: c="ac-diagonal-cros";break;
        //         case ChartMarkerType.Diamond: c="ac-diamond";break;
        //         case ChartMarkerType.Pentagon: c="ac-pentagon";break;
        //         case ChartMarkerType.Square: c="ac-square";break;
        //         case ChartMarkerType.Star10: c="ac-star-1";break;
        //         case ChartMarkerType.Star4: c="ac-star-2";break;
        //         case ChartMarkerType.Star5: c="ac-star-3";break;
        //         case ChartMarkerType.Star6: c="ac-star-4";break;
        //         case ChartMarkerType.Star7: c="ac-star-5";break;
        //         case ChartMarkerType.Trapezium: c="ac-trapezium";break;
        //         case ChartMarkerType.TriangleUp: c="ac-triangle-up";break;
        //         case ChartMarkerType.TriangleDown: c="ac-triangle-down";break;
        //         case ChartMarkerType.TriangleLeft: c="ac-triangle-left";break;
        //         case ChartMarkerType.TriangleRight: c="ac-triangle-right";break;
        //         default: c= "---";
        //     }
        //     $(`<span><i class="ac ${c}"></i>&nbsp;</span>`).appendTo(this.markerStyleBtn.nativeElement);
        // } else {
        //     $(`<span><i class="ac"></i>---</span>`).appendTo(this.markerStyleBtn.nativeElement);
        // }
    }

    private _markerSize: number = 20;
    public get markerSize(): number {
        return this._markerSize;
    }
    public set markerSize(v: number) {
        this._markerSize = v;
        this.updateCharts();
    }

    removeSelectedAnnotationTool(): void {
        this._chartComponents.forEach(cmp => {
            this.removeSelectedAnnotation(cmp.chart, cmp);
        });
    }

    removeAllSelectedAnnotationTools(): void {
        this._chartComponents.forEach(cmp => {
            this.removeAllAnnotation(cmp.chart, cmp);
        });
    }

    removeSelectedAnnotation(chart: anychart.charts.Stock, cmp: AChartComponent): void {
        if (chart) {
            let annotation: anychart.core.annotations.Base = chart.annotations().getSelectedAnnotation();
            if (annotation) {
                cmp.removeSelectedAnnotation();
                // chart.annotations().removeAnnotation(annotation);
            }
        }
    }

    removeAllAnnotation(chart: anychart.charts.Stock, cmp: AChartComponent): void {
        if (chart) {
            // chart.annotations().removeAllAnnotations();

            cmp.getAnnotations(cmp.chart.plot()).forEach(a => cmp.undecorateAnnotation(a));
            cmp.chart
                .plot()
                .annotations()
                .removeAllAnnotations();
            cmp.saveAnnotations();
        }
    }


    public get lineThickness (): number {
        return this.workspace.lineThickness;
    }

    public set lineThickness ( value: number ) {

        this.workspace.lineThickness = value;
     //   this._lineThickness = value;

        this._chartComponents.forEach(cmp => {
            if (cmp.chart) {
                let annotation: any = cmp.chart.annotations().getSelectedAnnotation();
                if (annotation && annotation.stroke !== undefined) {
                    annotation.stroke(this.strokeColor, this.lineThickness);
                    annotation.hovered().stroke(this.strokeColor, this.lineThickness);
                    annotation.selected().stroke(this.strokeColor, this.lineThickness);

                }
            }
        });


    }

    startDrawing(chart: anychart.charts.Stock): void {
        let threeLines = false;
        if(this.annotationTool == ChartAnnotationTool.ThreeLinesTrendChannel)
        {
            this.annotationTool = ChartAnnotationTool.TrendChannel;
            threeLines = true;
        }
        var strokeSettings: any = {
      //      thickness: this.lineThickness,
            color: this.strokeColor,
            thickness: this.lineThickness,
            // dash: strokeDash
        };
        var drawingSettings: any = {
            type: this.annotationTool,
            size: this.markerSize,
            markerType: this.annotationTool === ChartAnnotationTool.Marker ? this.annotationMarkerType : undefined,
            anchor:
                this.annotationTool === ChartAnnotationTool.Marker
                    ? MarkerAnchorMap.getAnchor(this.annotationMarkerType)
                    : undefined
            // fontSize: fontSize,
            // fontColor: fontColor
        };

        drawingSettings.fill = this.fillColor;
        drawingSettings.stroke = strokeSettings;
        drawingSettings.hovered = {
            stroke: strokeSettings
        };
        drawingSettings.selected = {
            stroke: strokeSettings
        };
        if (chart && drawingSettings.type === ChartAnnotationTool.Label) {
            $.extend(drawingSettings, {
                text: this.labelData.labelText,
                fontColor: this.labelData.fontColor,
                fontSize: this.labelData.fontSize,
                fontDecoration:
                    this.labelData.underline === true
                        ? "underline"
                        : this.labelData.lineThrough === true
                        ? "line-through"
                        : this.labelData.overline === true
                        ? "overline"
                        : "",
                fontStyle: this.labelData.italic === true ? "italic" : "",
                fontWeight: this.labelData.bold === true ? "bold" : "",
                hAlign:
                    this.labelData.center === true
                        ? "center"
                        : this.labelData.left === true
                        ? "left"
                        : this.labelData.right === true
                        ? "right"
                        : "start",
                anchor: "left-top",
                background: {
                    fill: this.fillColor,
                    stroke: strokeSettings
                },
                hovered: {
                    background: {
                        stroke: strokeSettings
                    }
                },
                selected: {
                    background: {
                        stroke: strokeSettings
                    }
                }
            });
        }
        const annotation = chart.annotations().startDrawing(drawingSettings);
        Utils.objectSetValue(annotation, 'threeLines', true);
    }

    updateChart(cmp: AChartComponent): void {
        if (cmp) {
            if (this._annotationTool === ChartAnnotationTool.None) {
                if (cmp.chart) {
                    cmp.chart
                        .annotations()
                        .unselect()
                        .cancelDrawing();
                }
            } else {
                this.startDrawing(cmp.chart);
            }
        }
    }

    updateCharts(): void {
      /*    if(this.chartInstanceService.selectedChart) {
            this.updateChart(this.chartInstanceService.selectedChart);
        }*/

        this._chartComponents.forEach(cmp => {
            this.updateChart(cmp);
        });
    }

    showModal(): void {
        if (this.chartInstanceService.selectedChart) {
            let m: NgbModalRef = this.modalService.open(ChartLabelModal, {
                backdrop: "static",
                size: "sm",
                centered: true,
                windowClass: "dark-modal"
            });

            (<ChartLabelModal>m.componentInstance).labelText = "";
            (<ChartLabelModal>m.componentInstance).fontColor = "white"; // this.strokeColor;
            (<ChartLabelModal>m.componentInstance).backgroundColor = this.fillColor;
            (<ChartLabelModal>m.componentInstance).bold = false;
            (<ChartLabelModal>m.componentInstance).italic = false;
            (<ChartLabelModal>m.componentInstance).left = false;
            (<ChartLabelModal>m.componentInstance).right = false;
            (<ChartLabelModal>m.componentInstance).center = false;
            (<ChartLabelModal>m.componentInstance).underline = false;
            (<ChartLabelModal>m.componentInstance).overline = false;
            (<ChartLabelModal>m.componentInstance).lineThrough = false;
            (<ChartLabelModal>m.componentInstance).fontSize = "10px";

            m.result
                .then(result => {
                    this.labelData = result;
                    this.annotationTool = ChartAnnotationTool.Label;
                })
                .catch(reason => {
                    console.error(reason);
                });
        }
    }

    colorFillChange($event: ColorEvent): void {
        this.fillColor = `rgba(${$event.color.rgb.r},${$event.color.rgb.g},${$event.color.rgb.b},${$event.color.rgb.a})`;
    }

    colorStokeChange($event: ColorEvent): void {
        this.strokeColor = `rgba(${$event.color.rgb.r},${$event.color.rgb.g},${$event.color.rgb.b},${$event.color.rgb.a})`;
    }

    ngAfterViewInit(): void {
        $(this.element.nativeElement)
            .find(".raised-bg")
            .hide();
        $(this.element.nativeElement)
            .find(".swatches-picker")
            .css("width", "220px");
        $(this.element.nativeElement)
            .find(".swatches-overflow")
            .mCustomScrollbar(<any>{
                axis: "y",
                theme: "inset-3",
                scrollbarPosition: "outside",
                alwaysShowScrollbar: 1,
                scrollButtons: {
                    enable: true
                },
                advanced: {
                    autoExpandHorizontalScroll: true
                },
                mouseWheel: {
                    enable: true
                },
                scrollInertia: 150,
                updateOnContentResize: true
                // axis:"y",
                // theme: "inset-3",// "minimal-dark",
                // scrollbarPosition: "outside",
                // alwaysShowScrollbar: 1, // 0,1,2
                // scrollButtons:{
                //     enable:true
                // },
                // advanced: {
                //     autoExpandHorizontalScroll: "yx"
                // },
                // mouseWheelPixels:150,
                // scrollInertia:150,
                // mouseWheel:true//,
                //updateOnContentResize:true
            });

        /**hide.bs doesnt work  */
        $(this.element.nativeElement)
            .find(".swatchclick")
            .on("click", function(e: any) {
                var target = $(e.target);
                if (target.attr("class") != "swatch") {
                    e.stopPropagation();
                }
            });
    }

    private _selectedLayoutChart: string = "4";
    set selectedLayoutChart(type: string) {
        this._selectedLayoutChart = type;
    }

    get selectedLayoutChart(): string {
        return this._selectedLayoutChart;
    }

    chartDisplayLayout(type: string): void {
        this.activeLayoutTypeService.subscriber.next(type);
        this.selectedLayoutChart = type;

        let newDisplay: IdisplayModeForChartDisplayMode = Object.assign(
            {},
            this.workspace.displayModeForChartDisplayMode
        );
        newDisplay[this.workspace.chartDisplayMode] = type;
        this.workspace.displayModeForChartDisplayMode = newDisplay;
    }

    public showLoginModal(): void {
     //   ShowLoginModal(this.modalService);
    }

    public showDemoUsersModal(): void {

        if(this.workspace.currentProvider == "OANDA")
        showLiveUsersModal(this.modalService, undefined, this.workspace.mobileMode);

        if(this.workspace.currentProvider == "DEMO")
        showDemoUsersModal(this.modalService, undefined, this.workspace.mobileMode);

        //showDemoUsersModal(this.modalService, undefined, this.workspace.mobileMode);
    }
    public showModalOrderEntry(): void {
        ShowModalOrderEntry("", 0, this.modalService, OrderOperationType.Buy, "", this.workspace.mobileMode,undefined,this.workspace.newOrderLayout);
    }

    private fullscreenMode: boolean = false;

    public runFullScreen() {
        console.log("asd");
        this.fullscreenMode = !this.fullscreenMode;
        setFullScreen(this.fullscreenMode);
    }
}

interface FsDocument extends HTMLDocument {
    mozFullScreenElement?: Element;
    msFullscreenElement?: Element;
    msExitFullscreen?: () => void;
    mozCancelFullScreen?: () => void;
}

export function isFullScreen(): boolean {
    const fsDoc = <FsDocument>document;

    return !!(
        (<any>fsDoc).fullscreenElement ||
        fsDoc.mozFullScreenElement ||
        (<any>fsDoc).webkitFullscreenElement ||
        fsDoc.msFullscreenElement
    );
}

interface FsDocumentElement extends HTMLElement {
    msRequestFullscreen?: () => void;
    mozRequestFullScreen?: () => void;
}

export function toggleFullScreen(): void {
    const fsDoc = <FsDocument>document;

    if (!isFullScreen()) {
        const fsDocElem = <FsDocumentElement>document.documentElement;

        if (fsDocElem.requestFullscreen) fsDocElem.requestFullscreen();
        else if (fsDocElem.msRequestFullscreen) fsDocElem.msRequestFullscreen();
        else if (fsDocElem.mozRequestFullScreen) fsDocElem.mozRequestFullScreen();
        else if ((<any>fsDocElem).webkitRequestFullscreen) (<any>fsDocElem).webkitRequestFullscreen();
    } else if (fsDoc.exitFullscreen) fsDoc.exitFullscreen();
    else if (fsDoc.msExitFullscreen) fsDoc.msExitFullscreen();
    else if (fsDoc.mozCancelFullScreen) fsDoc.mozCancelFullScreen();
    else if ((<any>fsDoc).webkitExitFullscreen) (<any>fsDoc).webkitExitFullscreen();
}

export function setFullScreen(full: boolean): void {
    if (full !== isFullScreen()) toggleFullScreen();
}
